module.exports = new __parcel__URL__("bp.451c5e76.webp").toString();